import { useEffect, useRef } from 'react';
import { mainMenuItems, adminMenuItems } from '@utils/menu';
import { findMatchingMenu } from '@utils/index';

export function usePathWatcher(setAppLayoutState, dynamicMenuItems) {
  const originalPushStateRef = useRef(null);
  const originalReplaceStateRef = useRef(null);

  useEffect(() => {
    const handlePathChange = () => {
      let pathname = window.location.pathname;

      if (pathname.startsWith('/app')) {
        pathname = pathname.replace(/^\/app/, '') || '/';
      }

      const mergedMainMenuItems = mainMenuItems.map((item) => {
        if (item.id === 'data_tables') {
          return {
            ...item,
            children: dynamicMenuItems,
            link: item?.link,
          };
        }
        return item;
      });

      const allMenuItems = [...mergedMainMenuItems, ...adminMenuItems];

      const { menuId, subMenuId } = findMatchingMenu(pathname, allMenuItems);

      setAppLayoutState((prevState) => {
        if (
          prevState.activeMenuId === menuId &&
          prevState.activeSubMenuId === subMenuId
        ) {
          return prevState;
        }
        const updated = {
          ...prevState,
          activeMenuId: menuId,
          activeSubMenuId: subMenuId,
        };
        localStorage.setItem('appLayoutState', JSON.stringify(updated));
        return updated;
      });
    };

    window.addEventListener('popstate', handlePathChange);

    if (window.top === window.self) {
      if (!originalPushStateRef.current) {
        originalPushStateRef.current = window.history.pushState.bind(
          window.history
        );
      }
      if (!originalReplaceStateRef.current) {
        originalReplaceStateRef.current = window.history.replaceState.bind(
          window.history
        );
      }

      const patchHistoryMethod = (original) => {
        return function (...args) {
          const result = original(...args);
          handlePathChange();
          return result;
        };
      };

      window.history.pushState = patchHistoryMethod(
        originalPushStateRef.current
      );
      window.history.replaceState = patchHistoryMethod(
        originalReplaceStateRef.current
      );
    }

    if (dynamicMenuItems.length > 0) {
      handlePathChange();
    }

    return () => {
      window.removeEventListener('popstate', handlePathChange);
      if (originalPushStateRef.current) {
        window.history.pushState = originalPushStateRef.current;
      }
      if (originalReplaceStateRef.current) {
        window.history.replaceState = originalReplaceStateRef.current;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dynamicMenuItems]);
}
